import { Button, ButtonProps } from '../buttons/Button';
import { IconButton } from '../buttons/IconButton';
import { DropdownProps, OptionsDropdown } from '../dropdown/options-dropdown/OptionsDropdown';
import { PanelDropdownProps, PanelDropdown } from '../dropdown/panel-dropdown/PanelDropdown';
import { ActionProps } from './constants';

export const CardActions = (props: ActionProps) => {
  const isButtonProps = (props: ActionProps): props is ButtonProps => {
    return 'children' in props;
  };
  const isPanelDropdownProps = (props: ActionProps): props is PanelDropdownProps => {
    return 'panel' in props && !('options' in props);
  };
  const isDropownProps = (props: ActionProps): props is DropdownProps => {
    return 'options' in props;
  };

  return (
    <div className="z-[51] flex gap-2 pl-2">
      {isButtonProps(props) ? (
        <Button {...props}>{props.children}</Button>
      ) : isPanelDropdownProps(props) ? (
        <PanelDropdown {...props} />
      ) : isDropownProps(props) ? (
        <OptionsDropdown {...props} />
      ) : (
        <IconButton {...props} />
      )}
    </div>
  );
};
